import { render, staticRenderFns } from "./page-banner.vue?vue&type=template&id=59d57df2&scoped=true"
import script from "./page-banner.vue?vue&type=script&lang=js"
export * from "./page-banner.vue?vue&type=script&lang=js"
import style0 from "./page-banner.vue?vue&type=style&index=0&id=59d57df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d57df2",
  null
  
)

export default component.exports